var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#clip0_18_216)" },
      React.createElement("path", { d: "M18.722 5.107a1.463 1.463 0 1 0-2.551 1.434c.59 1.05.902 2.246.902 3.46 0 3.9-3.173 7.072-7.073 7.072A7.08 7.08 0 0 1 2.927 10a7.081 7.081 0 0 1 9.565-6.622A1.463 1.463 0 1 0 13.522.64 9.96 9.96 0 0 0 10 0C4.486 0 0 4.486 0 10c0 5.515 4.486 10 10 10s10-4.485 10-10c0-1.715-.442-3.407-1.278-4.893z", fill: "#DBDBDB" }),
      React.createElement(
        "mask",
        { id: "mask0_18_216", style: {
            maskType: "alpha"
          }, maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "21", height: "20" },
        React.createElement("path", { d: "M18.723 5.106a1.463 1.463 0 1 0-2.552 1.435A7.07 7.07 0 0 1 17.073 10c0 3.9-3.173 7.073-7.073 7.073-3.9 0-7.073-3.173-7.073-7.073a7.081 7.081 0 0 1 9.565-6.622A1.463 1.463 0 1 0 13.522.64 9.96 9.96 0 0 0 10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10c0-1.715-.442-3.407-1.277-4.894z", fill: "#DBDBDB" })
      ),
      React.createElement(
        "g",
        { mask: "url(#mask0_18_216)" },
        React.createElement("path", { transform: "rotate(173.97 14.897 5.536)", fill: "url(#paint0_linear_18_216)", d: "M14.897 5.536h12.004v6.806H14.897z" })
      )
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "linearGradient",
        { id: "paint0_linear_18_216", x1: "17.306", y1: "8.627", x2: "24.595", y2: "8.079", gradientUnits: "userSpaceOnUse" },
        React.createElement("stop", { stopColor: "#fff" }),
        React.createElement("stop", { offset: "1", stopColor: "#DBDBDB" })
      ),
      React.createElement(
        "clipPath",
        { id: "clip0_18_216" },
        React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" })
      )
    )
  );
});